// CAROUSEL ITEM Label Component

export const itemLabelTemplate = (labelOptionalClass, labelText, labelIcon = '') =>`
    <div class="label ${labelOptionalClass}">${labelIcon}<span>${labelText}</span></div>
`;


